// hooks/useAdmins.js
import { useState, useEffect, useCallback } from 'react';
import { adminApi } from '../api/admins';
import toast from 'react-hot-toast';

export const useAdmins = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAdmins = useCallback(async () => {
    setLoading(true);
    try {
      const response = await adminApi.getAll();
      setAdmins(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      toast.error('Failed to fetch admins');
    } finally {
      setLoading(false);
    }
  }, []);

  const addAdmin = useCallback(async (data) => {
    try {
      const response = await adminApi.create(data);
      toast.success('Admin added successfully!');
      await fetchAdmins();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add admin');
      throw err;
    }
  }, [fetchAdmins]);

  const deleteAdmin = useCallback(async (id) => {
    try {
      await adminApi.delete(id);
      toast.success('Admin deleted successfully!');
      await fetchAdmins();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete admin');
      throw err;
    }
  }, [fetchAdmins]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  return { admins, loading, error, fetchAdmins, addAdmin, deleteAdmin };
};